import { ENVIRONMENT } from "../helpers/constants";

// How many copies of the label one run of the marquee holds — enough to span a wide
// viewport, since the two runs sit side by side and scroll one full run's width.
const REPEATS = 12;

// A non-production deployment announces itself: the environment name scrolls across a
// strip above everything else, so a test instance is never mistaken for the live one.
// Nothing renders when the variable is unset or names production.
export function EnvironmentBanner() {
  const label = ENVIRONMENT.toUpperCase();
  if (!label || label === "PRODUCTION") return null;

  const run = (
    <div className="glut-env-banner-run" aria-hidden="true">
      {Array.from({ length: REPEATS }, (_, i) => (
        <span key={i}>{label}</span>
      ))}
    </div>
  );

  return (
    <div className="glut-env-banner" role="status" aria-label={`${label} environment`}>
      <div className="glut-env-banner-track">
        {run}
        {run}
      </div>
    </div>
  );
}
